export const CHANGE_SHOPPING = "CHANGE_SHOPPING"
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const SET_SYSTEMCONFIGS = "SET_SYSTEMCONFIGS"

export const TRANSLATIONS_INSERT = "TRANSLATIONS_INSERT"
export const TRANSLATION_MESSAGE = "TRANSLATION_MESSAGE"
